<template>
  <div>
    <h3>Districts Not Yet Certified</h3>
    <div v-if="uncertifiedDistricts.length" class="mb-2">
      <strong>Total Districts Not Yet Certified: {{ uncertifiedDistricts.length }}</strong>
    </div>
    <b-table :items="uncertifiedDistricts" :fields="fields" striped hover small v-if="uncertifiedDistricts.length">
      <template v-slot:cell(districtLEA)="data">
        <div>
          <span :id="data.index + '-' + data.value">
            {{ leaFormatter(data.value) }}
          </span>
          <lea-tooltip :target-selector="data.index + '-' + data.value" :lea-number="data.value" />
        </div>
      </template>
      <template v-slot:cell(meetsDefinitionSummary)="data">
        <span>
          {{ data.item.meetsDefinitionCount }}
          <span v-if="data.item.meetsDefinitionPercentage != null">
            ({{ formatPercent(data.item.meetsDefinitionPercentage) }})
          </span>
        </span>
      </template>
      <template v-slot:cell(noIntensiveSupportSummary)="data">
        <span>
          {{ data.item.noIntensiveSupportCount }}
          <span v-if="data.item.noIntensiveSupportPercentage != null">
            ({{ formatPercent(data.item.noIntensiveSupportPercentage) }})
          </span>
        </span>
      </template>
    </b-table>
    <div v-else class="text-muted">
      All districts have certified for the selected year.
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import LeaTooltip from '@/components/LeaTooltip.vue'

export default {
  data() {
    return {
      uncertifiedDistricts: [],
      fields: [
        { key: 'districtLEA', label: 'District LEA', sortable: true },
        { key: 'totalTeachers', label: 'Total Teachers', sortable: true },
        { key: 'meetsDefinitionSummary', label: 'Meets Definition Of Teacher', sortable: false },
        { key: 'noIntensiveSupportSummary', label: 'No Intensive Support Of Teachers', sortable: false },
      ],
      loading: false,
    };
  },
  components: {
    LeaTooltip
  },
  computed: {
    ...mapState('tgsModule', ['loadedYears', 'fiscalYear']),
    isAdmin() {
      return this.$store.state.globalModule.userContext && this.$store.state.globalModule.userContext.isInsightsAdmin;
    }
  },
  watch: {
    fiscalYear: {
      immediate: true,
      handler(newVal) {
        if (newVal) this.fetchUncertifiedDistricts();
      }
    },
  },
  methods: {
    async fetchUncertifiedDistricts() {
      this.loading = true;
      try {
        const res = await fetch(`/api/merit-incentive/${this.fiscalYear}/uncertified`);
        if (res.ok) {
          this.uncertifiedDistricts = await res.json();
        } else {
          this.uncertifiedDistricts = [];
        }
      } catch (e) {
        this.uncertifiedDistricts = [];
      } finally {
        this.loading = false;
      }
    },
    leaFormatter(lea) {
      if (this.leaDictionary[lea])
        return `${lea} – ${this.leaDictionary[lea].name}`

      return lea
    },
    formatPercent(val) {
      if (val == null) return null;
      // If value is 0-1, treat as fraction; if >1, treat as already percent
      if (val > 1) return val.toFixed(2) + '%';
      return (val * 100).toFixed(2) + '%';
    }
  }
};
</script>

<style scoped>
/* Add any component-specific styles here */
</style>
